// @ts-check

/**
 * Constantes relacionadas aos turnos de trabalho para agrupamento de eventos de prescrição.
 * Centralizadas para fácil manutenção e configuração futura.
 *
 * NOTA: Essas constantes são usadas como fallback quando o campo `shiftStartTime`
 * (horário de início do plantão) da visita/prescrição não está definido.
 * Nesse caso, o sistema assume o início do primeiro turno às 07:00 (420 minutos).
 */

/**
 * Hora de início do primeiro turno (formato 24h).
 * Exemplo: 7 = 07:00
 * @type {number}
 */
export const SHIFT_START_HOUR = 7;

/**
 * Minutos de início do primeiro turno (derivado de SHIFT_START_HOUR).
 * Usado como fallback quando `shiftStartTime` da padVisit não existe.
 * @type {number}
 */
export const SHIFT_START_MINUTES = SHIFT_START_HOUR * 60;
